import React, { useState, useRef } from 'react';
import { MoreVertical } from 'lucide-react';
import OptionsMenu from './OptionsMenu';

/** Inline three-dot options (Export Excel/PDF) for use in any filter/toolbar row */
const PageOptionsButton = ({ onExportExcel, onExportPDF, showExport }) => {
  const [optionsOpen, setOptionsOpen] = useState(false);
  const anchorRef = useRef(null);

  return (
    <div className="relative flex-shrink-0" ref={anchorRef}>
      <button
        type="button"
        onClick={() => setOptionsOpen((o) => !o)}
        className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 border border-gray-200 transition-colors"
        title="Download / Options"
        aria-label="Page options"
      >
        <MoreVertical size={22} />
      </button>
      <OptionsMenu
        anchorRef={anchorRef}
        isOpen={optionsOpen}
        onClose={() => setOptionsOpen(false)}
        onExportExcel={onExportExcel}
        onExportPDF={onExportPDF}
        showExport={showExport}
      />
    </div>
  );
};

export default PageOptionsButton;
